module.exports = __webpack_public_path__ + "img/businessImg10.23ddd936.png";